import makeStyles from "@mui/styles/makeStyles";

export const useInputStyles = makeStyles((theme) => ({
  root: {
    boxShadow: `0 0 0 100px ${theme.palette.background.default} inset`,
    "& > fieldset": {
      border: `0.5px solid ${theme.palette.grey[600]} !important`,
      transition: "border-color  250ms",
      borderRadius: 4,
      "& > legend": {
        fontSize: "10.5px !important",
      },
    },
    "&not($disabled):hover > fieldset": {
      border: `0.5px solid ${theme.palette.grey[600]} !important`,
    },
    "&.Mui-disabled": {
      background: theme.palette.grey[100],
      boxShadow: "none",
      borderRadius: 4,
      "&:focus-within": {
        "& > fieldset": {
          border: `0.5px solid ${theme.palette.grey[600]} !important`,
        },
      },
    },
  },
  disabled: {},
  input: {
    boxSizing: "border-box",
    height: 40,
    fontSize: 14,
    "&:-webkit-autofill": {
      boxShadow: `0 0 0 100px ${theme.palette.background.default} inset`,
    },
    color: theme.palette.grey[900],
  },
  sizeSmall: {
    boxSizing: "border-box",
    height: 36,
    "& > $input": {
      fontSize: 12,
    },
    "& > fieldset > legend": {
      fontSize: "10px !important",
    },
  },
}));

export const useInputLabelStyles = makeStyles((theme) => ({
  root: {
    fontSize: 14,
    transform: "translate(13px, 11px) scale(1)",
    color: theme.palette.grey[600],
  },
  sizeSmall: {
    fontSize: 10,
    transform: "translate(15px, 10px) scale(1)",
  },
  shrink: {
    margin: "0 -6px",
    padding: "0 6px",
    fontSize: 14,
    fontWeight: "bold",
    background: theme.palette.grey[100],
    borderRadius: 2,
    "&.MuiFormLabel-root": {
      transform: "translate(15px, -6px) scale(0.75)",
    },
    color: theme.palette.grey[700],
  },
}));

export const useStyles = makeStyles(() => ({
  hiddenLabel: {
    "& label": {
      opacity: 0,
      position: "absolute",
      top: -999999,
    },
    "& legend": {
      opacity: 0,
      width: 0,
    },
    "& input": {
      "&::-webkit-input-placeholder": {},
    },
  },
  helperTextMargin: {
    marginBottom: 20,
  },
}));
